import { apis } from '@api/index';
import { format } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';
import { Accordion, Button, Header, Icon, Table } from 'semantic-ui-react';
import { UserRestrictInfo } from 'src/types/user.types';
import UserRestrictModal from './UserRestrictModal';

const UserRestrict = () => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [restrictModalOpen, setRestrictModalOpen] = useState(false);
  const [restrictModalType, setRestrictModalType] = useState<'ADD' | 'EDIT'>(
    'ADD',
  );
  const [restrictUsers, setRestrictUsers] = useState<UserRestrictInfo[]>([]);
  const [user, setUser] = useState<UserRestrictInfo | null>(null);

  const showRestrictModal = useCallback(() => setRestrictModalOpen(true), []);
  const closeRestrictModal = useCallback(() => {
    setRestrictModalOpen(false);
    setRestrictModalType('ADD');
    setUser(null);
  }, []);

  useEffect(() => {
    getRestrictUsers();
  }, []);

  const getRestrictUsers = async () => {
    const { users } = await apis.user.getRestrictedUsers();
    setRestrictUsers(users);
  };

  const deleteRestrictUser = async (restrictUser: UserRestrictInfo) => {
    if (!restrictUser) return;
    if (
      window.confirm(
        `[${restrictUser.id} / ${restrictUser.nickname}]의 제한 정보를 삭제하시겠습니까?`,
      )
    ) {
      await apis.user.deleteUserRestrict({ userId: restrictUser.id });
      alert('유저 제한 정보 삭제가 완료되었습니다.');
      const _restrictUsers = restrictUsers.filter(
        (u) => u.id !== restrictUser.id,
      );
      setRestrictUsers(_restrictUsers);
      closeRestrictModal();
    }
  };

  return (
    <Accordion>
      <Accordion.Title
        active={isAccordionOpen}
        index={1}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <Header as="h3" style={{ display: 'inline-block' }}>
          <Icon name="dropdown" />
          유저 제한 정보
        </Header>
        <Button
          size="mini"
          style={{ marginLeft: 10, display: 'inline' }}
          onClick={(e) => {
            e.stopPropagation();
            showRestrictModal();
          }}
          content="추가"
        />
      </Accordion.Title>
      <Accordion.Content active={isAccordionOpen}>
        <Table basic="very" size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>유저id</Table.HeaderCell>
              <Table.HeaderCell>이름</Table.HeaderCell>
              <Table.HeaderCell>닉네임</Table.HeaderCell>
              <Table.HeaderCell>신고금지종료시점</Table.HeaderCell>
              <Table.HeaderCell>접속차단시작시점</Table.HeaderCell>
              <Table.HeaderCell>사유</Table.HeaderCell>
              <Table.HeaderCell>수정/삭제</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {restrictUsers.map((restrictUser) => {
              return (
                <Table.Row key={restrictUser.id}>
                  <Table.Cell>{restrictUser.id}</Table.Cell>
                  <Table.Cell>{restrictUser.name}</Table.Cell>
                  <Table.Cell>{restrictUser.nickname}</Table.Cell>
                  <Table.Cell>
                    {restrictUser.reportBanEndDatetime
                      ? format(
                          new Date(restrictUser.reportBanEndDatetime),
                          'yyyy-MM-dd HH:mm:ss',
                        )
                      : '-'}
                  </Table.Cell>
                  <Table.Cell>
                    {restrictUser.permanentBanStartTime
                      ? format(
                          new Date(restrictUser.permanentBanStartTime),
                          'yyyy-MM-dd HH:mm:ss',
                        )
                      : '-'}
                  </Table.Cell>
                  <Table.Cell>{restrictUser.reason ?? '-'}</Table.Cell>
                  <Table.Cell>
                    <Button
                      size="mini"
                      value={restrictUser}
                      onClick={() => {
                        showRestrictModal();
                        setRestrictModalType('EDIT');
                        setUser(restrictUser);
                      }}
                      content="수정"
                    />
                    <Button
                      size="mini"
                      value={restrictUser}
                      onClick={() => deleteRestrictUser(restrictUser)}
                      content="삭제"
                    />
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>

        <UserRestrictModal
          isOpen={restrictModalOpen}
          type={restrictModalType}
          user={user}
          onClose={closeRestrictModal}
          onSubmitEnd={getRestrictUsers}
        />
      </Accordion.Content>
    </Accordion>
  );
};

export default UserRestrict;
